export default __webpack_public_path__ + "static/media/logo-ssc.86e92f0b.png";